import React, { useEffect, useState } from "react";
import { Routes, Route, useParams, Navigate } from "react-router-dom";
import useSellerIdByName from "../hooks/useSellerIdByName"; // Adjust this import path as needed

// Import all your components here
import Home from "../pages/Home";
import Shops from "../pages/Shops";
import Card from "../pages/Card";
import Details from "../pages/Details";
import Shipping from "../pages/Shipping";
import CategoryShops from "../pages/CategoryShop";
import SearchProducts from "../pages/SearchProducts";
import Payment from "../pages/Payment";
import Dashboard from "../pages/Dashboard";
import Index from "../components/dashboard/Index";
import Orders from "../components/dashboard/Orders";
import Wishlist from "../components/dashboard/Wishlist";
import Order from "../components/dashboard/Order";
import ConfirmOrder from "../pages/ConfirmOrder";
import StaticPage from "../components/StaticPage";
import Contact from "../pages/Contact";


const SellerWrapper = ({ isAdmin }) => {
  const { sellerName: paramSellerName } = useParams();
  const [sellerName, setSellerName] = useState(null);

  useEffect(() => {
    const handleSellerNameUpdate = () => {
      const storedSellerName = localStorage.getItem("sellerName");

      // If there's a param name and it's different from stored name, update storage
      if (
        paramSellerName &&
        (!storedSellerName || storedSellerName !== paramSellerName)
      ) {
        localStorage.setItem("sellerName", paramSellerName);
        setSellerName(paramSellerName);
      } else if (storedSellerName) {
        // If there's a stored name and no param name or they match
        setSellerName(storedSellerName);
      } else {
        // If neither exists, use param name as fallback
        setSellerName(paramSellerName);
      }
    };

    handleSellerNameUpdate();
  }, [paramSellerName]);

  // Set document title based on isAdmin
  useEffect(() => {
    // console.log("SellerWrapper - isAdmin:", isAdmin, "sellerName:", sellerName); // Debug log
    if (isAdmin) {
      document.title = "4POS eCommerce Admin";
    } else {
      document.title = "4POS eCommerce Customer";
    }
  }, [isAdmin]);

  const { sellerId, loading, error } = useSellerIdByName(sellerName);

  // Show loader while fetching seller ID
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!sellerId || !sellerName) {
    return <Navigate to="/not-found" />;
  }

  return (
    <Routes>
      <Route path="/" element={<Home sellerId={sellerId} sellerName={sellerName} />} />
      <Route path="/shops" element={<Shops sellerId={sellerId} sellerName={sellerName} />} />
      <Route path="/products" element={<CategoryShops sellerId={sellerId} sellerName={sellerName} />} />
      <Route
        path="/products/search"
        element={<SearchProducts sellerId={sellerId} sellerName={sellerName} />}
      />
      <Route path="/card" element={<Card sellerId={sellerId} sellerName={sellerName} />} />
      <Route
        path="/order/confirm"
        element={<ConfirmOrder sellerId={sellerId} sellerName={sellerName} />}
      />
      <Route path="/shipping" element={<Shipping sellerId={sellerId} sellerName={sellerName} />} />
      <Route path="/payment" element={<Payment sellerId={sellerId} sellerName={sellerName} />} />
      <Route
        path="/product/details/:slug"
        element={<Details sellerId={sellerId} sellerName={sellerName} />}
      />
      <Route
        path="/product/details/id/:productId"
        element={<Details sellerId={sellerId} sellerName={sellerName} />}
      />
      <Route
        path="/page/:pageName"
        element={<StaticPage sellerId={sellerId} sellerName={sellerName} />}
      />
      <Route path="/contact" element={<Contact sellerId={sellerId} sellerName={sellerName} />} />
      <Route 
        path="/dashboard" 
        element={
          <Dashboard isAdmin={isAdmin} sellerId={sellerId} sellerName={sellerName} />
        }
      >
        <Route path="" element={<Index sellerId={sellerId} sellerName={sellerName} />} />
        <Route path="my-orders" element={<Orders sellerId={sellerId} sellerName={sellerName} />} />
        <Route
          path="my-wishlist"
          element={<Wishlist sellerId={sellerId} sellerName={sellerName} />}
        />
        <Route
          path="order/details/:orderNumber"
          element={<Order sellerId={sellerId} sellerName={sellerName} />}
        />
      </Route>
    </Routes>
  );
};

export default SellerWrapper;
